import uuid from 'uuidv4';

export const createBlock = (
  type: string,
  children: Block[] = [],
  extra: any = {}
): Block => {
  //
  let meta;
  const packageVersion = process.env.PACKAGE_VERSION;

  if (extra.meta) {
    meta = extra.meta;
    if (
      meta &&
      ['module', 'topic', 'interaction'].includes(type?.toLowerCase())
    ) {
      meta.packageVersion = packageVersion;

      // console.log(
      //   'TYPE :',
      //   type,
      //   'HAS UPDATED META WITH PACKAGE_VERSION :',
      //   packageVersion
      // );
    }
  }

  return {
    id: uuid(),
    type: type,
    props: extra.props,
    meta,
    animator: extra.animator,
    children: children,
  };
};

export const cloneBlock = (block: Block): Block => {
  const children = Array.isArray(block.children)
    ? [...block.children]
    : block.children;

  return { ...block, children: children, props: { ...block.props } };
};

const reorder = (list: any[], startIndex: number, endIndex: number): any[] => {
  const reordered = [...list];
  const [removed] = reordered.splice(startIndex, 1);
  reordered.splice(endIndex, 0, removed);

  return reordered;
};

export const reorderChildren = (
  block: Block,
  startIndex: number,
  endIndex: number
): Block => {
  if (Array.isArray(block.children)) {
    const newBlock = cloneBlock(block);
    newBlock.children = reorder(block.children, startIndex, endIndex);
    return newBlock;
  }
  return block;
};

export interface Block {
  id: string;
  type: string;
  props?: {
    [key: string]: any;
  };
  project_id?: string;
  deletedAt?: number;
  meta?: {
    subType: string;
    layout?: string;
    packageVersion?: string;
  };
  children?: Block[] | string | null;
  animator?: {
    type: string;
    config: {
      [key: string]: any;
    };
  };
  __isSaving?: boolean;
  __delete?: boolean;
}

export interface Blocks {
  [key: string]: Block;
}

export declare type BlockList = Block[];

export interface Ref extends Block {
  type: 'Ref';
}

export class Block {
  public id: string;
  public type: string;
  public props?: { [key: string]: any };
  public meta?: { subType: string; layout?: string; packageVersion?: string };
  public children?: Block[] | string | null;
  public animator?: {
    type: string;
    config: { [key: string]: any };
  };

  constructor(data: Block) {
    this.id = data.id;
    this.type = data.type;
    this.props = data.props;
    this.meta = data.meta;
    this.children = data.children;
    this.animator = data.animator;
  }

  public static new(): Block {
    return new Block({} as Block);
  }
}
